const config = {
  version: '2.3.0',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts